import React, { createContext, useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { authService } from "../services/authService";

export const AuthContext = createContext();

export const useAuthContext = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuthContext must be used within an AuthProvider");
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [authToken, setAuthToken] = useState(localStorage.getItem("authToken"));
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  // Decode the token and set user information
  const refreshUser = (token) => {
    try {
      const userData = authService.decodeToken(token);
      setUser(userData);
    } catch (error) {
      console.error("Failed to decode token:", error);
      logout();
    }
  };

  useEffect(() => {
    if (authToken) {
      refreshUser(authToken);
    } else {
      setUser(null);
    }
    setIsLoading(false);
  }, [authToken]);

  const logout = () => {
    setAuthToken(null);
    setUser(null);
    localStorage.removeItem("authToken");
    // First navigate to login without any state
    navigate('/login', { replace: true });
    // Then clear any existing location state
    navigate('/login', { replace: true, state: null });
  };

  return (
    <AuthContext.Provider
      value={{
        authToken,
        setAuthToken: (token) => {
          localStorage.setItem("authToken", token);
          setAuthToken(token);
        },
        user,
        isLoading,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};